import * as Sentry from '@sentry/nextjs';

import { ecomVersionLabel } from './ecomVersion';

const BOT_USER_AGENT = /bot|crawler|spider|slurp|semrush|ahref/i;

export const tagBotTraffic = (userAgent?: string | null): void => {
  Sentry.setTag('is_bot', BOT_USER_AGENT.test(userAgent ?? '') ? 'true' : 'false');
};

export const tagSiteSlug = (slug?: string | null): void => {
  if (!slug) return;
  Sentry.setTag('site_slug', slug);
};

export const tagEcomVersion = (isEcom2: boolean): void => {
  Sentry.setTag('ecom_version', ecomVersionLabel(isEcom2));
};
